import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/userContext";
import { db } from "../firebase/firestore";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import Animate from "../Components/Animate";
import Spinner from "../Components/Spinner";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

const AlphaDogs = () => {
  const navigate = useNavigate();
  const { user, loading } = useUser();
  const [lastViewedLesson, setLastViewedLesson] = useState(null);
  const [lastViewedTraining, setLastViewedTraining] = useState(null);
  const [isLoadingProgress, setIsLoadingProgress] = useState(true);

  // ✅ Telegram WebApp инициализация для главной
useEffect(() => {
  if (window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp;
    
    tg.ready();
    tg.expand();
    
    // Принудительно скрываем кнопку на главной
    tg.BackButton.offClick();
    tg.BackButton.isVisible = false;
    
    console.log('AlphaDogs: Back button hidden');
  }

  return () => {
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.BackButton.offClick();
      tg.BackButton.isVisible = false;
    }
  };
}, []);

  // Дополнительный эффект для отслеживания состояния кнопки при фокусе
  useEffect(() => {
    const handleFocus = () => {
      if (window.Telegram?.WebApp) {
        const tg = window.Telegram.WebApp;
        // При возврате на главную убеждаемся, что кнопка скрыта
        tg.BackButton.offClick();
        tg.BackButton.isVisible = false;
        console.log('AlphaDogs: Back button hidden on focus');
      }
    };

    window.addEventListener('focus', handleFocus);
    
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  useEffect(() => {
    if (!loading) {
      loadLastViewedLesson();
    }
  }, [loading]);

  const loadLastViewedLesson = async () => {
    try {
      setIsLoadingProgress(true);
      
      // 1. Получаем все тренинги
      const trainingsSnap = await getDocs(collection(db, "trainings"));
      const trainings = trainingsSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      let foundLesson = null;
      let foundTraining = null;
      let latestProgressTime = 0;

      // 2. Проверяем прогресс каждого тренинга
      for (const training of trainings) {
        if (!training.lessons || training.lessons.length === 0) continue;

        // Получаем прогресс тренинга из localStorage
        const progressKey = `training_progress_${training.id}`;
        const savedProgress = localStorage.getItem(progressKey);
        
        if (savedProgress) {
          const completedLessons = JSON.parse(savedProgress);
          
          // 3. Находим последний завершенный урок
          if (completedLessons.length > 0) {
            const lastLessonId = completedLessons[completedLessons.length - 1];
            
            try {
              // Загружаем данные урока
              const lessonRef = doc(db, "masterClasses", lastLessonId);
              const lessonSnap = await getDoc(lessonRef);
              
              if (lessonSnap.exists()) {
                const lessonData = { id: lessonSnap.id, ...lessonSnap.data() };
                
                // Получаем время последнего прогресса
                const progressTimeKey = `progress_time_${training.id}_${lastLessonId}`;
                const progressTime = localStorage.getItem(progressTimeKey) || Date.now();
                
                // Сохраняем самый свежий урок
                if (parseInt(progressTime) > latestProgressTime) {
                  latestProgressTime = parseInt(progressTime);
                  foundLesson = lessonData;
                  foundTraining = training;
                }
              }
            } catch (error) {
              console.error("Ошибка загрузки урока:", error);
            }
          }
        }
      }

      setLastViewedLesson(foundLesson);
      setLastViewedTraining(foundTraining);
      
    } catch (err) {
      console.error("Ошибка загрузки прогресса:", err);
    } finally {
      setIsLoadingProgress(false);
    }
  };

  // Функция для перехода к продолжению тренинга
  const continueTraining = () => {
    if (lastViewedTraining) {
      navigate(`/master-class/${lastViewedTraining.id}`);
    } else {
      // Если нет прогресса, переходим к списку тренингов
      navigate("/club");
    }
  };

  // Функция перехода в клуб
  const goToClub = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Переход в клуб");
    navigate("/club");
  };

  // Функция перехода к материалам (обучение)
  const goToMaterials = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Переход к материалам (обучение)");
    navigate("/Training");
  };

  if (loading || isLoadingProgress) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Animate>
      <div className="min-h-screen w-full text-white relative">
        {/* ФОН */}
        <div
          className="fixed inset-0"
          style={{
            backgroundImage: "url('/bghome.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: -1
          }}
        />

        {/* ДЕКОР */}
        <div className="fixed bottom-0 left-0 right-0 h-[150px] bg-[radial-gradient(circle_at_center,rgba(120,0,255,0.15),transparent_70%)] z-0" />

        {/* КОНТЕНТ */}
        <div className="relative z-10 min-h-screen flex flex-col">
          <div className="pt-0">
            <Header />
          </div>
          
          <div className="flex-1 px-3 pt-6 pb-16 overflow-y-auto">
            {/* ТЕКСТ */}
            <div 
              className="text-[28px] leading-tight font-serif mb-4 text-left"
              style={{ color: '#C8AFE8' }}
            >
              Рады видеть тебя в пространстве
            </div>

            {/* БЛОК: МОИ ПРОДУКТЫ */}
            <div className="mb-4">
              <div 
                className="text-xl mb-2 text-left"
                style={{ color: '#ffffff' }}
              >
                Мои продукты
              </div>

              <button 
                onClick={goToMaterials}
                type="button"
                className="w-full rounded-2xl bg-[#241352] border border-white/20 p-3 flex gap-3 items-center hover:bg-white/10 active:bg-white/20 transition-colors cursor-pointer"
              >
                <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-xl">
                  <img
                    src="/product.png"
                    alt="Книги и материалы"
                    className="w-full h-full object-cover brightness-100 scale-110"
                  />
                </div>

                <div className="flex-1 min-w-0 text-left">
                  <div 
                    className="text-lg mb-1 break-words whitespace-normal font-medium"
                    style={{ color: '#C8AFE8' }}
                  >
                    Перейти к моим материалам
                  </div>
                </div>

                <div className="text-white/40 text-xl flex-shrink-0">›</div>
              </button>
            </div>

            {/* БЛОК: КЛУБ */}
            <div className="mb-4">
              <div 
                className="text-xl mb-2 text-left"
                style={{ color: '#ffffff' }}
              >
                Клуб
              </div>

              <button 
                onClick={goToClub}
                type="button"
                className="w-full rounded-2xl bg-[#241352] border border-white/20 p-3 flex gap-3 items-center hover:bg-white/10 active:bg-white/20 transition-colors cursor-pointer"
              >
                <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-xl">
                  <img
                    src="/clubhome.png"
                    alt="Клуб"
                    className="w-full h-full object-cover brightness-100 scale-110"
                  />
                </div>

                <div className="flex-1 min-w-0 text-left">
                  <div 
                    className="text-lg mb-1 break-words whitespace-normal font-medium"
                    style={{ color: '#C8AFE8' }}
                  >
                    Перейти в клуб
                  </div>
                  <div 
                    className="text-sm"
                    style={{ color: '#8D85D5' }}
                  >
                    Библиотека рисования • подписка • сообщество
                  </div>
                </div>

                <div className="text-white/40 text-xl flex-shrink-0">›</div>
              </button>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </Animate>
  );
};

export default AlphaDogs;